var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "KGrid",
    [
      _c(
        "KGridItem",
        { attrs: { layout8: { span: 4 }, layout12: { span: 6 } } },
        [
          _vm._t("header", function () {
            return [_c("h1", [_vm._v(_vm._s(_vm.headerText))])]
          }),
        ],
        2
      ),
      _c(
        "KGridItem",
        {
          staticClass: "buttons",
          style: { padding: _vm.windowIsSmall ? "0 8px 16px" : "0" },
          attrs: {
            layout8: { span: 4, alignment: "right" },
            layout12: { span: 6, alignment: "right" },
          },
        },
        [_vm._t("options")],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }